export default __webpack_public_path__ + "static/media/Etta 9781408355008.2ac828d6.jpg";